'use client';

import { useState } from 'react';
import { Text } from '~/components/ui/Text';
import { Button } from '~/components/ui/Button';
import { Container } from '~/components/container';
import { Heading } from '~/components/ui/Heading';
import { IconBrandDiscord } from '@tabler/icons-react';
import Link from 'next/link';
import * as Sentry from '@sentry/nextjs';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [isRendered, setIsRendered] = useState(false);

  if (!isRendered) {
    Sentry.captureException(error);
    setIsRendered(true);
  }

  return (
    <Container className="my-10 flex h-full flex-col px-8">
      <Heading className="mb-10">Something went wrong!</Heading>
      <Text className="my-10">
        Please{' '}
        <Button asChild variant="link" size="sm">
          <Link href="/company/contact-us">contact support</Link>
        </Button>{' '}
        or reach out to us on{' '}
        <Button asChild variant="link" size="sm">
          <Link href="https://discord.gg/fireworks-ai" target="_blank">
            Discord{' '}
            <IconBrandDiscord
              role="img"
              strokeWidth="1.5px"
              aria-hidden="true"
              className="text-foreground-secondary mr-1 inline-block h-4 w-4"
            />
          </Link>
        </Button>{' '}
        for assistance.
      </Text>

      <Button onClick={() => reset()} variant="secondary" className="self-start">
        Try page refresh
      </Button>
    </Container>
  );
}
